import React, {useEffect} from "react";
import styled from "styled-components";
import LogoutIcon from "react-icons/lib/io/log-out";
import get from "lodash/get";
import {clearAuth} from "@unibuddy/machop/Auth/actions/authActions";
import Tooltip from "@unibuddy/machop/Experimental/General/components/Tooltip/Tooltip";
import TextBlock from "@unibuddy/machop/Experimental/Typography/components/TextBlock/TextBlock";
import Inline from "@unibuddy/machop/Experimental/Layout/components/Inline/Inline";
import Button from "@unibuddy/machop/Experimental/General/components/Button/Button";
import useAuth from "@unibuddy/machop/Auth/hooks/useAuth";
import Hidden from "@unibuddy/machop/Experimental/Layout/components/Hidden/Hidden";
import {AUTH_TRANSFER, AUTH_CLEARED} from "@unibuddy/machop/Utils/Constants";
import LiveEventAvatar from "../../../Chat/components/LiveEventAvatar/LiveEventAvatar";
import {useEmbeddedWidgetProvider} from "../../../EmbeddedWidget/EmbeddedWidget";

const Logout = styled(Button)`
    font-weight: 400;
    height: 100%;
`;

function LogoutButton({dispatch}) {
    const {authState} = useAuth();
    const user = get(authState, "me.anyUser");
    const {iframeRef} = useEmbeddedWidgetProvider();

    useEffect(() => {
        window.addEventListener("message", (message) => {
            if (message.data.name === AUTH_CLEARED) {
                dispatch(clearAuth());
            }
        });
    }, [dispatch]);

    if (!user) return null;

    return (
        <Tooltip label="Logout">
            <Logout
                aria-label="Logout"
                clear
                onClick={() => {
                    if (iframeRef && iframeRef.current && authState.token) {
                        iframeRef.current.contentWindow.postMessage(
                            {name: AUTH_TRANSFER, value: {token: false, me: false}},
                            ONIX_URL,
                        );
                    } else {
                        dispatch(clearAuth());
                    }
                }}
            >
                <Inline verticalAlign="center" space="xsmall" wrap="nowrap">
                    <LogoutIcon aria-hidden />
                    <TextBlock size="large">
                        <Hidden below="tablet">
                            {user.firstName} {user.lastName}
                        </Hidden>
                    </TextBlock>
                    <LiveEventAvatar sender={user} />
                </Inline>
            </Logout>
        </Tooltip>
    );
}

export default LogoutButton;
